import { useSelector, useDispatch } from "react-redux";
import { actions as CommonActions } from "../store/commonRedux/actions";

export const useTheme = () => {
  const theme = useSelector(({ common }) => common.theme || "light");
  const dispatch = useDispatch();
  const isDark = theme === "dark";

  const toggle = () =>
    dispatch(CommonActions.setVariables({ theme: isDark ? "light" : "dark" }));

  const chartColors = {
    foreColor: isDark ? "#94a3b8" : "#64748b",
    gridColor: isDark ? "#334155" : "#f1f5f9",
    tooltipBg: isDark ? "#1e293b" : "#ffffff",
    tooltipBorder: isDark ? "#334155" : "#e2e8f0",
  };

  /**
   * ApexCharts paints SVG through JS, so it cannot read the --kpi-* custom
   * properties the rest of the UI uses. These are the literal values of those
   * tokens per theme: a chart left on the Apex defaults ends up with colours
   * that belong to no theme and go muddy on the dark surface.
   */
  const chartPalette = isDark
    ? ["#4dabf7", "#4ade80", "#fb923c", "#c084fc", "#2dd4bf", "#f87171", "#facc15", "#818cf8"]
    : ["#1677ff", "#16a34a", "#ea580c", "#9333ea", "#0d9488", "#dc2626", "#ca8a04", "#4f46e5"];

  /** Fixed colours for task states, so "done" is the same green everywhere. */
  const stateColors = {
    done: isDark ? "#4ade80" : "#16a34a",
    inProgress: isDark ? "#4dabf7" : "#1677ff",
    open: isDark ? "#94a3b8" : "#94a3b8",
    stalled: isDark ? "#fb923c" : "#ea580c",
    overdue: isDark ? "#f87171" : "#dc2626",
  };

  return { theme, isDark, toggle, chartColors, chartPalette, stateColors };
};
